import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { selfServiceSlice } from "../../../../../../../../../store/selfServiceSlice";

/**
 * @desc Watch and update product details form.
 */
export const useWatchProductForm = ({ watch, product, formProduct }) => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Dispatch store updates on form changes.
   */
  const handleWatch = useCallback(
    (value, { name }) => {
      if (name) {
        dispatch(
          selfServiceSlice.actions.updateProductForm({
            sku: product.sku,
            formProduct: {
              [name]: value[name],
            },
          })
        );
      }
    },
    [dispatch, product.sku]
  );

  // SIDE EFFECTS -------------------------------------------------------------

  /**
   * @desc Only once, update self service form w/ product data.
   */
  useEffect(() => {
    if (product.sku && formProduct) {
      dispatch(
        selfServiceSlice.actions.updateProductForm({
          sku: product.sku,
          formProduct,
        })
      );
    }
    // eslint-disable-next-line
  }, []);

  /**
   * @desc Subscribe to form changes.
   */
  useEffect(() => {
    const subscription = watch(handleWatch);

    return () => subscription.unsubscribe();
  }, [watch, handleWatch]);
};
